__turbopack_context__.v({
  "thankYouButton": "currentTab3-module-scss-module__AU92vq__thankYouButton",
  "thankYouContainer": "currentTab3-module-scss-module__AU92vq__thankYouContainer",
  "thankYouDescription": "currentTab3-module-scss-module__AU92vq__thankYouDescription",
  "thankYouTitle": "currentTab3-module-scss-module__AU92vq__thankYouTitle",
});
